import { Component, Input } from '@angular/core';
import { NgIf, NgStyle } from '@angular/common';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: true,
    imports: [NgIf, NgStyle]
})
export class LoadingComponent {

    @Input() width = 1;
    @Input() height = 1;
    @Input() display: boolean;

    constructor() { }

}
